import { type SynopticCategory } from '@core/referential/synoptic-category.enum'
import { SynopticType } from '@core/referential/synoptic-type.enum'
import { GetSynopticsResponseSchema } from '@shared/schema/synoptic.get-all.schema'
import { queryOptions } from '@tanstack/react-query'

import { apiFetch } from '@/lib/api-fetch'

// Catalogue des modules d'une catégorie à modules (chaufferie, PAC / groupe froid) : les synoptics
// de type `component` de cette catégorie, qui ne sont rattachés à aucun site (`unlocated`) — ce sont
// des briques réutilisables, assemblées par le générateur pour composer le synoptique d'un site. Les
// catégories sont hermétiques : la clé de cache porte la catégorie, un catalogue ne sert jamais l'autre.
export function synopticModulesQuery(category: SynopticCategory) {
  return queryOptions({
    queryKey: ['module-synoptic', 'modules', category] as const,
    async queryFn() {
      const searchParams = new URLSearchParams({ type: SynopticType.COMPONENT, category, unlocated: 'true' })

      const rawResponse = await apiFetch.get('synoptic', { searchParams })

      if (!rawResponse.ok) {
        throw new Error(`Failed to fetch ${category} modules`)
      }

      try {
        return await GetSynopticsResponseSchema.parseAsync(await rawResponse.json())
      } catch (error) {
        throw new Error(`Failed to parse ${category} modules response`, { cause: error })
      }
    },
  })
}
